/* global routes, subscribe, publish, PUB_SUB_EVENTS */

(function () {
  if (window.__cartProtectionSyncInited) return;
  window.__cartProtectionSyncInited = true;

  var syncing = false;

  function getCartItemsEl() {
    return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  function getSections() {
    var cart = getCartItemsEl();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender();
    }
    return [
      { id: 'main-cart-items', section: 'main-cart-items', selector: '.js-contents' },
      { id: 'main-cart-footer', section: 'main-cart-footer', selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }

  function patchSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    if (window.CartOperations) window.CartOperations.render(parsedState);
    else getSections().forEach(function (section) {
      var host = document.getElementById(section.id);
      if (!host) return;
      var elementToReplace = host.querySelector(section.selector) || host;
      var html = parsedState.sections[section.section];
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (!parsed) return;
      elementToReplace.innerHTML = parsed.innerHTML;
    });

    if (typeof parsedState.item_count === 'number') {
      var cartEl = getCartItemsEl();
      if (cartEl) cartEl.classList.toggle('is-empty', parsedState.item_count === 0);
      var cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
    }
  }

  async function reconcile(event) {
    if (syncing) return;
    if (event && event.source === 'cart-protection-sync') return;

    syncing = true;
    try {
      // ALWAYS fetch the full cart fresh. event.cartData looks tempting —
      // it's the AJAX response that triggered this event, so it's fresh by
      // definition — but for /cart/add.js it's a PARTIAL response containing
      // only the just-added line items, not the entire cart.
      //
      // Concrete failure mode: user picks a 2-Year plan in cart picker.
      // Picker calls /cart/add.js → response.items = [X] (only the new
      // protection line, no main item). Picker publishes 'cart-items' with
      // cartData = response. Sync receives this, builds hostQty = {} (no
      // non-protection items in response), sees X's _protection_for_id is
      // "46790719733934" (the main host) — not in hostQty (empty) — and
      // classifies X as an orphan. Sync then POSTs /cart/update.js
      // {[X.key]: 0} — DELETING THE USER'S JUST-PICKED PLAN. The user-
      // visible symptom is "selected a plan, then it auto-cancels."
      //
      // PR #319 introduced the event.cartData preference to avoid Shopify
      // read-replica stale reads. It traded one rare race for one common,
      // catastrophic data-loss bug. Reverting: always fetch /cart.js.
      // cache:'no-store' cuts the browser/CDN cache; replica lag remains
      // possible but is benign in our logic — sync only deletes orphans
      // (host gone) and syncs quantity, neither of which is harmful when
      // the read missed a recent commit (worst case: a no-op until the
      // next cartUpdate event, when the replica has caught up).
      if (event?.cartDataIsComplete && !event.cartData.items.some((item) => item.properties?._protection_for_id) && !Object.keys(window.CartOperations?.orphanShippingUpdates(event.cartData) || {}).length) return;

      var cartUrl = (typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url : '/cart') + '.js';
      var cart = await fetch(cartUrl, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      }).then(function (r) { return r.json(); });

      if (!cart || !Array.isArray(cart.items)) return;

      // hostExists 记录同一 variant 的主商品是否仍在购物车，用于孤儿判定；
      // hostQty 记录同一 variant 下所有**未拒保**主商品行的数量之和，用于按件补保。
      //
      // 三点都是必需的：
      // - 存在性不能排除拒保行：顾客可在购物车内为拒保商品补买护航，
      //   此时保护行不是孤儿，但不应自动按件补保。
      // - 累加而非覆盖：加上 _protection_declined 标记后，同一 variant 会合法地
      //   存在多条主商品行（一条已投保、一条已拒保）。原来的 `= i.quantity`
      //   是覆盖，谁在后面谁说话，数量会算错。
      // - 排除拒保行：用户明确选过「No thanks」的那部分不该被追加保险。
      var hostExists = {};
      var hostQty = {};
      cart.items.forEach(function (i) {
        var props = i.properties || {};
        if (props._protection_for_id) return; // 保护行自身
        var key = String(i.variant_id);
        hostExists[key] = true;
        if (props._protection_declined) return; // 用户明确拒保的那部分
        hostQty[key] = (hostQty[key] || 0) + i.quantity;
      });

      var updates = window.CartOperations?.orphanShippingUpdates(cart) || {};
      var hasChange = Object.keys(updates).length > 0;
      cart.items.forEach(function (i) {
        if (!i.properties || !i.properties._protection_for_id) return;
        var hostId = String(i.properties._protection_for_id);
        if (!hostExists[hostId]) {
          // 主商品已不在购物车 —— 清掉孤儿保护行。
          updates[i.key] = 0;
          hasChange = true;
          return;
        }

        var targetQty = hostQty[hostId];
        if (typeof targetQty === 'undefined') return;
        if (targetQty !== i.quantity) {
          // 双向对齐：保险是按件卖的（一台一份），所以主商品数量变了保险就该跟着
          // 变 —— 购物车里把助行器从 1 改成 3，保险理应从 1 份变 3 份。
          //
          // 曾经为了堵「拒保反被加收」把这里改成只向下对齐（`i.quantity >
          // targetQty`），那是修错了地方：它顺手把上面这条正常的按件倍增也禁掉了，
          // 结果 3 台助行器只投 1 份保，既少收钱又留下 2 台没有保障。
          //
          // 真正的问题出在「拒保的那部分被算进了应投保数量」：protection-flow 对
          // decline 路径也挂同样的 _available_plan_*，两次加购的 properties 完全
          // 相同，Shopify 合并成一行 qty=2，这里就误以为该投 2 份。
          // 线上实测过：应收 $157.99、实收 $177.98。
          //
          // 现在由 protection-flow 给拒保行打 _protection_declined 标记，
          // 上面构建 hostQty 时已把它们排除，两种情况从源头上分开了。
          updates[i.key] = targetQty;
          hasChange = true;
        }
      });

      if (!hasChange) return;

      var sectionList = getSections().map(function (s) { return s.section; });
      var updateUrl = (typeof routes !== 'undefined' && routes.cart_update_url ? routes.cart_update_url : '/cart/update') + '.js';
      var response = await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          updates: updates,
          sections: sectionList,
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error('cart-protection-sync update failed: ' + response.status);

      var data = await response.json();
      patchSections(data);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        // CartItems skips events containing all rendered sections, and this
        // source prevents another reconcile. patchSections already applied fresh
        // sections from the /cart/update.js response. Letting Dawn fire its
        // own /cart?section_id=main-cart-items refetch would overwrite our
        // DOM with the cart state read AFTER our commit but possibly BEFORE
        // commit visibility on the read replica (Shopify's read-after-write
        // window). Result was: picker reverts from State A to State B
        // ~1 second after the user selected a plan, even though the cart
        // total still includes the plan price.
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-protection-sync', cartData: data, cartDataIsComplete: true });
      }
    } catch (err) {
      console.error('[cart-protection-sync]', err);
      if (window.CartOperations) await window.CartOperations.recover();
    } finally {
      syncing = false;
    }
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      window.setTimeout(init, 50);
      return;
    }
    const sync = (event) => window.CartOperations ? window.CartOperations.run(() => reconcile(event)) : reconcile(event);
    subscribe(PUB_SUB_EVENTS.cartUpdate, sync);
    sync({ source: 'init' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
